import React from "react";
import { Link } from "react-router-dom";
import { Offcanvas, Tabs, Tab, Toast, Badge } from "react-bootstrap";
import { ActionHandlerFunction, AdminApprovalGroup, AdminUser } from "@preveil-api";
import { AdminUIActionTypes, PrivateRoutes, account_types, OrgUserStatus, Account, getAccountTooltip } from "src/common";
import { Icon } from "src/components";
import { AccountPanel, DevicePanel } from ".";

type AllProps = {
  current_selected_user: AdminUser;
  total_admin_users: number;
  current_account: Account;
  recovery_groups: AdminApprovalGroup[];
  users_list: AdminUser[];
  allow_add_devices?: boolean;
  add_device_overrides: string[];
  admin_approval_group?: AdminApprovalGroup;
  handleAction: ActionHandlerFunction;
};

function SidePanelComponent(props: AllProps) {
  const { total_admin_users, current_selected_user, current_account, recovery_groups, allow_add_devices, add_device_overrides, users_list,
    admin_approval_group, handleAction } = props;
  const { display_name, account_type, updates_pending, subsume_request_id, user_pending_delete_total } = current_selected_user;
  const updates_pending_message = !!user_pending_delete_total && user_pending_delete_total >= 1 ? "Delete approval pending" :
    updates_pending && updates_pending > 1 ? `${updates_pending} updates are awaiting approval` :
      `${updates_pending} update is awaiting approval`;

  // Description: handle hide modal.
  function handleHideModal() {
    handleAction({ actionType: AdminUIActionTypes.ShowSideNavMenu });
  }

  return (
    <Offcanvas
      className="sidebar wide-panel user-sidebar"
      show={true}
      placement="end"
      backdrop={false}
      onHide={handleHideModal}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title as="h2">
          <Icon tooltip={getAccountTooltip(account_type)} className={`${account_type === account_types.full ? "icon-user-plus" : account_type === account_types.express ? "icon-user" : "icon-user-plus inactive"}`} />
          {display_name}
        </Offcanvas.Title>
        {
          (current_selected_user.status === OrgUserStatus.invited || current_selected_user.status === OrgUserStatus.pending) &&
          <Badge bg="info">{current_selected_user.status}</Badge>
        }
      </Offcanvas.Header>
      <Offcanvas.Body>
        {
          !!updates_pending ?
            <Link to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.requests_route}`}
              className="user-update">{updates_pending_message}</Link> :
            (current_selected_user.status === OrgUserStatus.invited &&
              <Link to={`/${PrivateRoutes.admin_route}/${PrivateRoutes.requests_route}/${subsume_request_id}`}>
                <Toast bg="warning" show={true} className="mt-0 mb-3">
                  <Toast.Body>
                    This user has not yet accepted the invitation to join your organization.
                  </Toast.Body>
                </Toast></Link>
            )
        }
        <Tabs defaultActiveKey="account" id="user-account">
          <Tab eventKey="account" title="Account" className="account-panel">
            <AccountPanel current_account={current_account} total_admin_users={total_admin_users} current_selected_user={current_selected_user} recovery_groups={recovery_groups} handleAction={handleAction} users_list={users_list} admin_approval_group={admin_approval_group}></AccountPanel>
          </Tab>
          <Tab eventKey="devices" title="Devices" className="device-panel">
            <DevicePanel current_user={current_selected_user} current_account={current_account} allow_add_devices={allow_add_devices} add_device_overrides={add_device_overrides} />
          </Tab>
        </Tabs>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default React.memo(SidePanelComponent);
